import { InjectionToken } from '@angular/core';

export const HIDE_TOKENS = new InjectionToken<string>('HIDE_TOKENS');
export const BLOB_CDN_ENDPOINT = new InjectionToken<string>(
  'BLOB_CDN_ENDPOINT',
);
export const SERVERLESS = new InjectionToken<boolean>('SERVERLESS');
